import { ThemeProvider } from "@mui/material"
import { createContext, useCallback, useContext, useMemo, useState } from "react"
import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { LightTheme } from "../../Theme/Light"
import { DarkTheme } from "../../Theme/Dark"

export const ThemeContext = createContext()

export const useAppTheme = () => {
    return useContext(ThemeContext)
}

export const ThemeAppProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('ThemeContext', 'contexto')
    const [themeName, setThemeName] = useState('light')

    const toggleTheme = useCallback(() => {
        setThemeName(oldTheme => oldTheme === 'light' ? 'dark' : 'light')
    }, [])

    const theme = useMemo(() => {
        if (themeName === 'light') return LightTheme

        return DarkTheme
    }, [themeName])

    const value = { themeName, toggleTheme, theme }
    return (
        <ThemeContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    )
}
